import { createFileRoute } from '@tanstack/react-router';

import { pageHead } from '../lib/seo';
import { RSS_DESCRIPTION, RSS_FEEDS, canonical } from '../lib/site';
import { PageContainer } from '../components/layout/page-container';
import { PageHeader } from '../components/ui/page-header';

/**
 * RSS index (/rss) — a static directory of the per-corner RSS feeds, mirroring
 * the HTML sitemap (/sitemap). The feeds themselves are XML endpoints served by
 * the Node server (server.mjs → renderFeed), so each entry is a plain <a>, not
 * a router <Link>.
 */
export const Route = createFileRoute('/rss')({
  head: () => pageHead({ title: 'RSS 피드', description: RSS_DESCRIPTION, url: canonical('/rss'), type: 'website' }),
  component: RssPage,
});

function RssPage() {
  return (
    <PageContainer>
      <PageHeader title="RSS 피드" description={RSS_DESCRIPTION} />

      <ul className="space-y-4">
        {RSS_FEEDS.map((feed) => (
          <li key={feed.href}>
            <a href={feed.href} className="text-sm font-bold text-primary hover:underline">
              {feed.label}
            </a>
            <p className="text-sm text-text-muted">{feed.description}</p>
          </li>
        ))}
      </ul>
    </PageContainer>
  );
}
